import { FC } from "react";
import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";
import { useCurrencies } from "./ServerSideStates";
import { MazakaSelect } from "../MazakaSelect";
import useCapitalize from "../Adress/helpers/useCapitalize";

const GeneralCurrencies: FC<GeneralSelectInputs> = (props) => {
 

  const currecies = useCurrencies()
  let { capitalize } = useCapitalize();
  return (
    <>
        <MazakaSelect
              name={props.name}
              xs={props.xs}
              sm={props.sm}
              md={props.md}
              lg={props.lg}
              xl={props.xl}
              loading={currecies.isLoading || currecies.isFetching}
              disabled={currecies.isLoading || currecies.isFetching || props.disabled}
              className={props.className}
              showSearch={true}
              allowClear={props.allowClear || false}
              filterOption={(input, option: any) =>
                (option.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              label={props.label}
              options={
                currecies.data?.data
                  ? currecies.data?.data.map((item: any) => {
                      return {
                        key: item.id,
                        value: item.id,
                        label: capitalize(item.name),
                      };
                    })
                  : []
              }
              placeholder={props.placeholder}
              mode={props.mode}
              onChange={props.onChange}
              value={props.value}
              rules={props.rules}
            />
    </>
  );
};

export default GeneralCurrencies;
